import { render, staticRenderFns } from "./modifyApi.vue?vue&type=template&id=1432e0ea&scoped=true&"
import script from "./modifyApi.vue?vue&type=script&lang=js&"
export * from "./modifyApi.vue?vue&type=script&lang=js&"
import style0 from "./modifyApi.vue?vue&type=style&index=0&id=1432e0ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1432e0ea",
  null
  
)

export default component.exports